import { api } from "@/lib/api";
import type { AlertData, RecoveryTokenPayload } from "../Types/types";

export interface EditPasswordPayload extends RecoveryTokenPayload {
  password: string;
  password_confirmation: string;
}

export interface EditPasswordResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export const decodeRecoveryToken = (encoded: string): RecoveryTokenPayload => {
  const decoded = JSON.parse(atob(encoded));

  return {
    email: decoded.email,
    tipo_id: decoded.tipo_id,
    num_id: decoded.num_id,
    token: decoded.token,
  };
};

export const validateRecoveryToken = (payload: RecoveryTokenPayload) =>
  api.post("/api/auth/validate_token", payload);

export const editPasswordRequest = async (
  payload: EditPasswordPayload
): Promise<EditPasswordResponse> => {
  const { data } = await api.post<EditPasswordResponse>(
    "/api/auth/editPassword",
    payload
  );
  return data;
};

export const mapTokenValidationError = (status?: number): AlertData => {
  if (status === 400) {
    return {
      title: "URL inválida",
      message:
        "El enlace no es válido o ha expirado. Solicita nuevamente la recuperación de contraseña.",
    };
  }
  if (status === 404) {
    return {
      title: "Usuario no encontrado",
      message:
        "No se encontró un usuario asociado a este enlace de recuperación.",
    };
  }
  if (status === 422) {
    return {
      title: "Datos inválidos",
      message: "La información del enlace no es válida. Intenta nuevamente.",
    };
  }
  return {
    title: "Error",
    message: "No fue posible validar el enlace de recuperación.",
  };
};

export const mapEditPasswordError = (
  status?: number,
  error?: string
): string => {
  if (status === 422 && error) return error;
  if (status === 400) return error || "Token inválido o expirado";
  if (status === 404) return "Usuario no encontrado";
  if (status === 408) return "Tiempo de espera agotado. Intenta nuevamente.";
  if (status === 503) return "tipo no disponible. Intenta más tarde.";
  return error || "Error en la solicitud. Intenta nuevamente.";
};
